import(/* webpackMode: "eager", webpackExports: ["BlogPage"] */ "/home/skillsewa/r/skillsewa.com-trans/src/components/landing/desktop/blogs/BlogPage.tsx");
